import { NOTES, SONG, type NoteEvent, type Pitch } from "./score";
export const beatTime = (beat: number) => SONG.leadIn + (beat * 60) / SONG.bpm;
export const pitchMidi = (pitch: Pitch) =>
  ({ C: 0, D: 2, E: 4, F: 5, G: 7, A: 9, B: 11 })[pitch[0] as "C"] +
  (Number(pitch.slice(1)) + 1) * 12;
export const pitchHz = (pitch: Pitch) =>
  440 * 2 ** ((pitchMidi(pitch) - 69) / 12);
export type ScheduledNote = NoteEvent &
  Readonly<{ time: number; duration: number; end: number }>;
export const schedule = (
  notes: readonly NoteEvent[],
): readonly ScheduledNote[] =>
  notes.map((note) => ({
    ...note,
    time: beatTime(note.startBeat),
    duration: (note.durationBeats * 60) / SONG.bpm,
    end: beatTime(note.startBeat + note.durationBeats),
  }));
export const EVENTS = schedule(NOTES);
